import {componentConfig, componentLoader} from "../../lib/component_initializer";
import {NumericPrice, NumericPriceConfig} from "./numeric_price";

export const numericPriceLoader = function (options = {}) {
    componentLoader(componentConfig(NumericPrice, NumericPriceConfig.componentTypeKey, NumericPriceConfig.baseHtmlClass), options);
};
